import React, { useEffect } from "react";
import { Box, Button, Grid, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";
import AppForm from "components/Shared/AppForm";
import { CustomCountryPhoneInput } from "components/Shared/CustomCountryPhoneInput";
import { useNavigate } from "react-router-dom";

import AppSwitch from "components/Shared/AppSwitch";

const INITIAL_STATE = {
  name: "",
  phone: "",
  alternatePhone: "",
  email: "",
  address: "",
  isActive: true,
};

const ContractorUserForm = ({
  contractorUserDetail = null,
  isBusy = false,
  onSubmit = () => { },
}) => {
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...INITIAL_STATE,
    },
  });


  useEffect(() => {
    if (contractorUserDetail) {
      reset({
        ...contractorUserDetail,
      });
    } else {
      reset(INITIAL_STATE);
    }
  }, [contractorUserDetail, reset]);

  const handlePayload = (data) => {
    const payload = {
      ...data,
    };
    onSubmit(payload);
  };

  return (
    <AppForm>
      <AppForm.Content>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Please provide full Name." }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  required
                  size="small"
                  label="Full Name"
                  placeholder="Enter Full Name"
                  error={!!errors?.name}
                  helperText={errors?.name?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Please provide an email.",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              }}
              render={({ field }) => (
                <BaseTextField
                  {...field}
                  fullWidth
                  required
                  label="Email"
                  placeholder="Enter email"
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                />
              )}
            />
          </Grid>
          <Grid item md={6}>
            <Controller
              name="phone"
              control={control}
              rules={{
                required: "Phone is required",

                validate: (value) => {
                  const digits = value.replace(/\D/g, "");
                  if (digits.length < 7 || digits.length > 17) {
                    return "Phone number must be between 9 and 16 digits";
                  }
                  return true;
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <CustomCountryPhoneInput
                  placeholder="Phone Number"
                  label="Phone*"
                  {...field}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="alternatePhone"
              control={control}
              render={({ field }) => (
                <CustomCountryPhoneInput
                  label="Alternate Phone Number"
                  placeholder="Enter alternate number"
                  {...field}
                />
              )}
            />
            {errors.alternatePhone && (
              <p className="error">{errors.alternatePhone.message}</p>
            )}
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="address"
              control={control}
              rules={{ required: "Please provide address." }}
              render={({ field }) => (
                <BaseTextField
                  {...field}
                  required
                  fullWidth
                  label="Address"
                  placeholder="Enter Address"
                  error={!!errors?.address}
                  helperText={errors?.address?.message}
                />
              )}
            />
          </Grid>

          {contractorUserDetail && (
            <Grid item xs={6}>
              <Controller
                name="isActive"
                control={control}
                render={({ field }) => (
                  <AppSwitch {...field} label="Is Active?" />
                )}
              />
            </Grid>
          )}
        </Grid>

        <Box display="flex" justifyContent="flex-end" paddingY={2} gap={2}>
          <Button disabled={isBusy} onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={isBusy}
            onClick={handleSubmit(handlePayload)}
          >
            {contractorUserDetail ? "Update" : "Add"}
          </Button>
        </Box>
      </AppForm.Content>
    </AppForm>
  );
};

export default ContractorUserForm;